export default __webpack_public_path__ + "static/media/vectuel_logo_t.6f50e539.png";